import { render, staticRenderFns } from "./TopNavbar.vue?vue&type=template&id=651b05e0&scoped=true&"
import script from "./TopNavbar.vue?vue&type=script&lang=js&"
export * from "./TopNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651b05e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('651b05e0')) {
      api.createRecord('651b05e0', component.options)
    } else {
      api.reload('651b05e0', component.options)
    }
    module.hot.accept("./TopNavbar.vue?vue&type=template&id=651b05e0&scoped=true&", function () {
      api.rerender('651b05e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/TopNavbar.vue"
export default component.exports